import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { findItemInArray } from "../../utils/ManageArray";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { formatDate, formatSplitKey } from "../../commons/FormatValue";
import { FormCheckComponent, FormControlComponent } from "../FormComponent";
import Table from "../Table";
import PrintButton from "../PrintButton";
import ReportHeadComponent from "../ReportHeadComponent";
import CardDisplayComponent from "../CardDisplayComponent";
import CustomersService from "../../services/customer.service";
import CustContractItemsService from "../../services/custcontractitem.service";

const PreviewJobNotiForm = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const Item = state?.data?.Inform?.ItemOther || [];
  const Inform = state?.data?.Inform || [];
  const Job = state?.data?.Job || [];
  const Seq = state?.data?.Seq || [];
  const [Branch, setBranch] = useState({});
  const [CustContractItems, setCustContractItems] = useState([]);

  const inputField = {
    Inform: [
      {
        name: "Inform_Doc_No",
        label: "หมายเลขแจ้งงาน",
        className: { col: "mb-3", input: "mb-1" },
        size: 12
      }
    ],
    Inform1: [
      {
        name: "Inform_By_Id",
        label: "ผู้แจ้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5",
        plusString: `${Inform?.InformEmployee?.Employee_Name} ${Inform?.InformEmployee?.Employee_Surname}`
      },
      {
        name: "Inform_Section",
        label: "แผนกที่แจ้ง",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      {
        name: "Project_No",
        label: "หมายเลขโครงการ",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      {
        name: "Service_Call",
        label: "Call No.",
        className: { col: "mb-3", input: "mb-1" },
        size: 2
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Ref_Doc_No",
        label: "อ้างอิงหมายเลขแจ้งงาน",
        className: { col: "mb-3", input: "mb-1" }
      },
      {
        name: "Customer.Cus_Code",
        label: "รหัสลูกค้าหลัก (BP Master Code)",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5"
      },
      {
        name: "Customer.Cus_Name",
        label: "ชื่อลูกค้า",
        className: { col: "mb-3", input: "mb-1" },
        size: 6
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        format: (row) => formatDate(row)
      },
      {
        name: "Customer.Cus_Address",
        label: "ที่อยู่",
        size: "8_5",
        className: { col: "mb-3", label: "mb-1" },
        as: "textarea",
        rows: 3,
        plusString: `${Inform?.Customer?.Cus_Address}
        ${!Inform?.Customer?.Cus_Road || ""}
        ${!Inform?.Customer?.Cus_District || ""}
        ${!Inform?.Customer?.Cus_SubDistrict || ""}
        ${!Inform?.Customer?.Cus_Province || ""}
        ${!Inform?.Customer?.Cus_ZipCode || ""}`
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        className: { col: "mb-3", input: "mb-1" }
      },
      {
        name: "BP_Code",
        label: "รหัสสาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5",
        findValue: { value: "Cus_Code" }
      },
      {
        name: "Cus_NumBranch",
        label: "เลขที่สาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: 2,
        findValue: { value: "Cus_NumBranch" }
      },
      {
        name: "Cus_Name",
        label: "ชื่อลูกค้า/สาขา",
        className: { col: "mb-3", input: "mb-1" },
        size: 4,
        findValue: { value: "Cus_Name" }
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        className: { col: "mb-3", input: "mb-1" }
      },
      {
        name: "Customer.Cus_Address",
        label: "สถานที่จัดส่งสินค้า",
        className: { col: "mb-3", input: "mb-1" },
        size: "8_5"
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        className: { col: "mb-3", input: "mb-1" }
      },
      { name: "GoogleMap_Link", label: "Google Map", size: 6 },
      { name: "Customer.Cus_ContactEmail", label: "Email", size: "2_5" },
      { name: "", size: null },
      { name: "Cus_Contract_Tel2", label: "เบอร์โทรผู้ติดต่อ 2", size: 3 }
    ],
    Inform2: [
      {
        name: "Job_Name",
        label: "ชื่องาน",
        className: { col: "mb-3", input: "mb-1" },
        size: 6
      },
      {
        name: "To_Section",
        label: "ถึงแผนก",
        className: { col: "mb-3", input: "mb-1" },
        size: "2_5"
      },
      { name: "", className: { col: "mb-3", input: "mb-1" }, size: null },
      {
        name: "Sub_Team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        className: { col: "mb-3", input: "mb-1" }
      },
      { name: "Subject_Inform", label: "เรื่องที่แจ้ง", size: 6 },
      { name: "Remark", label: "หมายเหตุ", size: 6 }
    ],
    Inform3: [
      {
        name: "Cus_Cpec_Tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        className: { col: "mb-3", label: "mb-1 fw-bold" },
        as: "textarea",
        rows: 10,
        size: 12
      }
    ],
    Radio: [
      { name: "PM_List", label: "มี PM" },
      { name: "PM_List", label: "ไม่มี PM" },
      { name: "PM_List", label: "รอสรุป" }
    ],
    Inform4: [
      {
        name: "Contract_No",
        label: "เลขที่สัญญา",
        className: { col: "mb-3", input: "mb-1" },
        size: 6
      },
      {
        name: "PM_Per_Year",
        label: "ความถี่ (จำนวน PM/ปี)",
        className: { col: "mb-3", input: "mb-1" },
        findValue: {
          CustContractItems,
          key: "Contract_No",
          value: "PM_Per_Year"
        },
        size: 6
      },
      {
        name: "CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        format: (row) => formatDate(row),
        size: 6
      },
      {
        name: "CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        format: (row) => formatDate(row),
        size: 6
      }
    ],
    Checkbox: [
      { name: "JobList1", label: "สำรวจหน้างาน" },
      { name: "JobList2", label: "งานรื้อถอน" },
      { name: "JobList3", label: "ติดตั้ง" },
      { name: "JobList4", label: "เทสระบบ" },
      { name: "JobList5", label: "Training/ส่งมอบ" },
      { name: "JobList6", label: "เก็บน้ำ" }
    ],
    Check: [
      {
        name: "Check_1",
        label: "ผู้ตรวจสอบ",
        className: { input: "border-0 border-bottom rounded-0" }
      },
      { name: "", size: null },
      {
        name: "Check_2",
        label: "ผู้อนุมัติ",
        className: { input: "border-0 border-bottom rounded-0" }
      }
    ]
  };
  const columns = {
    Item: [
      { name: "ลำดับ", selector: (row) => row.rowIndex, width: "110px" },
      {
        name: "รหัสสินค้า/อะไหล่/อุปกรณ์",
        selector: (row) => row.Item?.Item_Code,
        minWidth: "300px"
      },
      {
        name: "รายละเอียดสินค้า/อะไหล่/อุปกรณ์",
        selector: (row) => row.Item?.Item_Name_TH,
        minWidth: "400px"
      },
      { name: "จำนวน", selector: (row) => row.Item_Install_Qty },
      { name: "หน่วย", selector: (row) => row.Uom_Unit },
      { name: "ราคา", selector: (row) => row.Item_Price_Per_Unit },
      { name: "ราคารวม", selector: (row) => row.Item_Amount },
      { name: "สกุลเงิน", selector: (row) => row.Item_Price_Unit }
    ],
    Job: [
      { name: "ลำดับ", selector: (row) => row.rowIndex, width: "110px" },
      { name: "รายการค่าบริการ", selector: (row) => row.Oth_Des },
      { name: "ราคา", selector: (row) => row.Oth_Price },
      { name: "สกุลเงิน", selector: (row) => row.Oth_Price_Unit },
      { name: "หมายเหตุ", selector: (row) => row.Remark }
    ]
  };

  const showData = (field) => {
    return field.map(
      (
        {
          name,
          label,
          size,
          className,
          as,
          rows,
          format,
          plusString,
          findValue
        },
        idx
      ) => {
        const joinData = formatSplitKey(name, ".", Inform);

        const result =
          (name === "Seq_Oth_No" && Seq?.[name]) ||
          // (name === "Customer.Cus_Address" && joinData  ) ||
          (findValue && Branch?.[findValue?.value]) ||
          (findValue && CustContractItems?.[findValue?.value]) ||
          (plusString && plusString) ||
          (format && format(joinData)) ||
          joinData ||
          "";

        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={className?.col}
          >
            {name && (
              <FormControlComponent
                readOnly
                as={as}
                rows={rows}
                type="text"
                name={name}
                label={label}
                className={{
                  ...className,
                  label: `w-100 text-truncate ${className?.label}`
                }}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };
  useEffect(() => {
    if (state?.data?.Inform?.BP_Code) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: CustomersService.getCustomers(
          state?.data?.Inform?.BP_Code
        ),
        callback: (res) => setBranch(res)
      });
    }
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractItemsService.getCustContractItems(
        `?keyword=${state?.data?.Inform?.Contract_No}`
      ),
      callback: ({ items }) => {
        setCustContractItems(
          findItemInArray(
            items,
            "Contract_No",
            state?.data?.Inform?.Contract_No
          )
        );
      }
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        cardClassName="position-relative"
        header={{
          title: {
            className: "mb-0 fs-2 text-center",
            text: "แสดงและพิมพ์ใบแจ้งงาน"
          },
          button: <PrintButton componentRef={canvasRef} />
        }}
        body={{
          ref: canvasRef,
          element: (
            <>
              <CardDisplayComponent
                cardBorder={1}
                header={{
                  title: {
                    className: "mb-0 fs-2 text-center",
                    text: `ใบแจ้งงาน : ${Inform?.JobType?.Job_Type_Name} - ${Inform?.JobTypeSub?.Job_Type_Sub_Name}`
                  }
                }}
                body={{
                  as: Row,
                  element: (
                    <>
                      <Col
                        sm={9}
                        className="ReportHead mb-3 d-flex align-items-center"
                      >
                        <ReportHeadComponent formName="job notification form" />
                      </Col>
                      <Col as={Row} sm={3} className="mx-0 px-0">
                        {showData(inputField.Inform)}
                      </Col>
                      <Col as={Row} sm={12} className="mx-0 px-0">
                        {showData(inputField.Inform1)}
                      </Col>
                    </>
                  )
                }}
              />

              <CardDisplayComponent
                cardBorder={1}
                header={{
                  title: {
                    className: "mb-0 fs-2 text-center",
                    text: `บันทักข้อมูลรายละเอียดงานที่แจ้ง`
                  }
                }}
                body={{ as: Row, element: showData(inputField.Inform2) }}
              />

              <CardDisplayComponent
                cardBorder={1}
                body={{ element: <Table data={Item} column={columns.Item} /> }}
              />

              <CardDisplayComponent
                cardBorder={1}
                body={{ element: <Table data={Job} column={columns.Job} /> }}
              />

              <CardDisplayComponent
                cardBorder={1}
                cardClassName="mb-1"
                body={{
                  as: Row,
                  element: (
                    <>
                      <Col sm={5}>{showData(inputField.Inform3)}</Col>

                      <Col sm={4}>
                        <Card.Title className="mb-0 py-2 text-center bg-info fs-3">
                          Preventive Maintenance
                        </Card.Title>
                        <Row className="justify-content-center">
                          {inputField.Radio.map(({ name, label }, idx) => (
                            <Col key={idx} sm={1} className="mb-3 w-auto">
                              <FormCheckComponent
                                readOnly
                                key={idx}
                                name="list"
                                label={label}
                                type="radio"
                                className={{ check: "py-3" }}
                                checked={Inform?.[name] === label}
                              />
                            </Col>
                          ))}
                        </Row>
                        <Row>{showData(inputField.Inform4)}</Row>
                      </Col>

                      <Col sm={3}>
                        <Card.Title className="mb-0 py-2 text-center fs-3">
                          รายละเอียดการทำงาน
                        </Card.Title>
                        <Row className="justify-content-center">
                          {inputField.Checkbox.map(({ name, label }, idx) => (
                            <FormCheckComponent
                              key={idx}
                              name="list"
                              label={label}
                              type="checkbox"
                              className={{ check: "py-2 p-5" }}
                              checked={Inform?.[name] === label}
                              readOnly
                            />
                          ))}
                        </Row>
                      </Col>
                      {showData(inputField.Check)}
                    </>
                  )
                }}
              />
            </>
          )
        }}
        footer={{
          className: "pt-0 text-center",
          element: (
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/general_job/create", { state: { name: "data" } })
              }
            >
              ย้อนกลับ
            </Button>
          )
        }}
      />
    </>
  );
};

export default PreviewJobNotiForm;
